module.exports = __webpack_public_path__ + "img/check-computer.b82024d6.jpeg";